import Constants from './constants';
import { intl } from '../locales/localesConfig';

const engineFunctionsDefinition = {
  functionsList: {
    SUM: {
      params: [],
      enableAddParams: true,
      addParamsType: Constants.formulaEditor.functionParamsTypes.formula,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.SUM" }),
      code: "SUM",
      hide: true
    },
    MIN: {
      params: [],
      enableAddParams: true,
      addParamsType: Constants.formulaEditor.functionParamsTypes.formula,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.MIN" }),
      code: "MIN",
      tooltipDescription: {
        show: true,
        paramCases: 1,
      },
    },
    MAX: {
      params: [],
      enableAddParams: true,
      addParamsType: Constants.formulaEditor.functionParamsTypes.formula,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.MAX" }),
      code: "MAX",
      tooltipDescription: {
        show: true,
        paramCases: 1,
      },
    },
    COUNT: {
      params: [],
      enableAddParams: true,
      addParamsType: Constants.formulaEditor.functionParamsTypes.formula,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.COUNT" }),
      code: "COUNT",
      hide: true
    },
    AVERAGE: {
      params: [],
      enableAddParams: true,
      addParamsType: Constants.formulaEditor.functionParamsTypes.formula,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.AVERAGE" }),
      code: "AVERAGE",      
      tooltipDescription: {
        show: true,
        paramCases: 1,
      },
    },
    ABSOLUTE: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.functionValue" }) }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.ABSOLUTE" }),
      code: "ABSOLUTE",      
      tooltipDescription: {
        show: true,
      },
    },
    ROUND: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.functionValue" }) },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.roundDecimals" }) }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.ROUND" }),
      code: "ROUND",
      tooltipDescription: {
        show: true,
      },
    },
    IFERROR: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.functionValue" }) },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.functionValueIfError" }), optionalFormulaOverrideString: true }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.IFERROR" }),
      code: "IFERROR",
      tooltipDescription: {
        show: true,
      },
    },
    IF: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.logicalFormula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.condition" }) },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.valueTrue" }), optionalFormulaOverrideString: true },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.valueFalse" }), optionalFormulaOverrideString: true }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.IF" }),
      code: "IF",
      tooltipDescription: {
        show: true,
      },
    },
    SUMX: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.metric, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.iterateMetric" }) },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.iterateFormula" }) }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.SUMX" }),
      code: "SUMX",
      deprecated: true,      
    },
    REDUCEX: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.metric, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.iterateMetric" }) },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.iterateFormula" }) },
        { type: Constants.formulaEditor.functionParamsTypes.string, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.iterateReducer" }) }
      ],
      enableAddParams: true,
      addParamsType: Constants.formulaEditor.functionParamsTypes.logicalFormula,
      addParamsLabel: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.iterateCondition" }),
      addParamsAddButtonLabel: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.iterateConditionAddLabel" }),
      addParamsLimit: 1,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.REDUCEX" }),
      code: "REDUCEX",
      tooltipDescription: {
        show: true,
      },
    },
    COLX: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.metricsList, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.metricName" }) },
        { type: Constants.formulaEditor.functionParamsTypes.metricDimensionsOrValueList, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.metricDimensionName" }) },
        { conditional: true, type: Constants.formulaEditor.functionParamsTypes.metricObjectAttributesList, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.metricObjectAttributeName" }) }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.COLX" }),
      code: "COLX",
      tooltipDescription: {
        show: false,
        returnCases: 2,
      },
    },
    PRECOLX: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.metricsList, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.metricName" }) },
        { type: Constants.formulaEditor.functionParamsTypes.metricDimensionsOrValueList, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.metricDimensionName" }) },
        { conditional: true, type: Constants.formulaEditor.functionParamsTypes.metricObjectAttributesList, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.metricObjectAttributeName" }) }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.PRECOLX" }),
      code: "PRECOLX",
      tooltipDescription: {
        show: false,
        returnCases: 3,
      },
    },
    INFOX: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.metricsList, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.metricName" }) },
        { type: Constants.formulaEditor.functionParamsTypes.string, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.iterateValue" }) }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.INFOX" }),
      code: "INFOX",
      tooltipDescription: {
        show: true,
        returnCases: 5,
      },
    },
    MARKVALUE: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.string, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.markValueName" }) }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.MARKVALUE" }),
      code: "MARKVALUE",
      tooltipDescription: {
        show: true,
      },      
    },
    AND: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.logicalFormula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.logicFunctionDefaultParameter"})},
      ],
      enableAddParams: true,
      addParamsType: Constants.formulaEditor.functionParamsTypes.logicalFormula,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.AND" }),
      code: "AND",
      tooltipDescription:{
        show: true,
      }
    },
    OR: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.logicalFormula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.logicFunctionDefaultParameter"})},
      ],
      enableAddParams: true,
      addParamsType: Constants.formulaEditor.functionParamsTypes.logicalFormula,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.OR" }),
      code: "OR",
      tooltipDescription:{
        show: true,
      }
    },
    IN_METRIC_INCLUDES_FAKE_FUNCTION: {
      params: [],
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.IN_METRIC_INCLUDES_FAKE_FUNCTION" }),
      code: "IN_METRIC_INCLUDES_FAKE_FUNCTION"
    },
    ATTRIBUTE: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.string, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.entity" }) },
        { type: Constants.formulaEditor.functionParamsTypes.string, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.entityAttribute" }) },
        { conditional: true, type: Constants.formulaEditor.functionParamsTypes.optionsToSetDimension, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.entityPeriodDefinition" }) }
        
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.ATTRIBUTE" }),
      code: "ATTRIBUTE",
      tooltipDescription:{
        show: true,
      }
    },
    EXTRACT: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.extractText" }) },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.extractFrom" }) },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.extractTo" }) }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.EXTRACT" }),
      code: "EXTRACT",
      tooltipDescription:{
        show: true,
      }
    },
    REPLACE: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.replaceText" }) },
        { type: Constants.formulaEditor.functionParamsTypes.string, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.replaceToReplace" }) },
        { type: Constants.formulaEditor.functionParamsTypes.string, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.replaceNewTest" }), allowEmpty: true }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.REPLACE" }),
      code: "REPLACE",
      tooltipDescription: {
        show: true,
      },
    },
    UPPERCASE: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.uppercaseText" }) },
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.UPPERCASE" }),
      code: "UPPERCASE",
      tooltipDescription: {
        show: true,
      },
    },
    LOWERCASE: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.lowercaseText" }) },
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.LOWERCASE" }),
      code: "LOWERCASE",
      tooltipDescription: {
        show: true,
      },
    },
    INDEXOF: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.indexOfText" }), optionalFormulaOverrideString: true },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.indexOfSubtext" }), optionalFormulaOverrideString: true }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.INDEXOF" }),
      code: "INDEXOF",
      tooltipDescription:{
        show: true,
      }
    },
    DAYS: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.from" }), optionalFormulaOverrideString: true, format: Constants.selectKeys.metric.dataType.DATE },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.to" }), optionalFormulaOverrideString: true, format: Constants.selectKeys.metric.dataType.DATE }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.DAYS" }),
      code: "DAYS",
      tooltipDescription:{
        show: true,
      }
    },
    MONTHS: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.from" }), optionalFormulaOverrideString: true, format: Constants.selectKeys.metric.dataType.DATE },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.to" }), optionalFormulaOverrideString: true, format: Constants.selectKeys.metric.dataType.DATE }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.MONTHS" }),
      code: "MONTHS",
      tooltipDescription:{
        show: true,
      }
    },
    EXTRACTDATE: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.date" }) },
        { type: Constants.formulaEditor.functionParamsTypes.string, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.dateElement" }) }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.EXTRACTDATE" }),
      code: "EXTRACTDATE",
      tooltipDescription:{
        show: true,
      }
    },
    CREATEDATE: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.createDay" }) },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.createMonth" }) },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.createYear" }) }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.CREATEDATE" }),
      code: "CREATEDATE",
      tooltipDescription:{
        show: true,
      }
    },
    CREATEDATETIME: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.createDay" }) },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.createMonth" }) },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.createYear" }) },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.createHour" }) },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.createMinute" }) },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.createSecond" }) }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.CREATEDATETIME" }),
      code: "CREATEDATETIME",
      tooltipDescription:{
        show: true,
      }
    },
    DAYOFTHEWEEK: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.date" }) }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.DAYOFTHEWEEK" }),
      code: "DAYOFTHEWEEK",
      tooltipDescription:{
        show: true,
      }
    },
    ADDDAYS: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.adddaysDate" }) },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.adddaysDays" }) }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.ADDDAYS" }),
      code: "ADDDAYS",
      tooltipDescription:{
        show: true,
      }
    },
    VALIDATEBYSYSTEMDIMENSION: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.string, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.entity" }) },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.functionValue" }) }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.VALIDATEBYSYSTEMDIMENSION" }),
      code: "VALIDATEBYSYSTEMDIMENSION",
      tooltipDescription:{
        show: true,
      }
    },
    CHILEANRUTVALIDATIONCODE: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.chileanRutWithoutVerificationCode" }) }
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.CHILEANRUTVALIDATIONCODE" }),
      code: "CHILEANRUTVALIDATIONCODE",
      tooltipDescription:{
        show: true,
      }
    },
    CALENDAR: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.calendarSelect" }), optionalFormulaOverrideString: true },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.calendarFrom" }), optionalFormulaOverrideString: true, format: Constants.selectKeys.metric.dataType.DATE },
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.calendarTo" }), optionalFormulaOverrideString: true, format: Constants.selectKeys.metric.dataType.DATE },
        { type: Constants.formulaEditor.functionParamsTypes.string, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.calendarDateType" }) },
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.CALENDAR" }),
      code: "CALENDAR",
      tooltipDescription:{
        show: true,
      }
    },
    LOADMETRIC: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.metric, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.dynamicMetric" })},
        { type: Constants.formulaEditor.functionParamsTypes.formula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.functionValue" })}      
      ],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.LOADMETRIC" }),
      code: "LOADMETRIC"
    },
    CANCELCALCULATION: {
      params: [],
      enableAddParams: false,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.CANCELCALCULATION" }),
      code: "CANCELCALCULATION",
      tooltipDescription: {
        show: true,
      },
    },
    DIMENSIONRANGE: {
      params: [
        { type: Constants.formulaEditor.functionParamsTypes.string, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.dimensionRangeLogicOperator" })},
        { type: Constants.formulaEditor.functionParamsTypes.logicalDimensionFormula, label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionParamLabels.dimensionRangeDefaultParameter"})}
      ],
      enableAddParams: true,
      addParamsType: Constants.formulaEditor.functionParamsTypes.logicalDimensionFormula,
      label: intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionNames.DIMENSIONRANGE" }),
      code: "DIMENSIONRANGE",
      deprecated: true,
    }
  }
};

export default engineFunctionsDefinition;



// WEBPACK FOOTER //
// ./source/definitions/engineFunctionsDefinition.js